var _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.1211 4.76383C28.8456 4.52898 28.5224 4.35681 28.1737 4.25926C27.8251 4.1617 27.4594 4.14108 27.1021 4.19883L6.35378 7.54539C5.27695 7.71523 4.29645 8.26482 3.58962 9.09476C2.88278 9.92469 2.49629 10.9802 2.50003 12.0703V14.1666C2.50003 14.3877 2.58783 14.5996 2.74411 14.7559C2.9004 14.9122 3.11237 15 3.33339 15H29.1667C29.3877 15 29.5997 14.9122 29.7559 14.7559C29.9122 14.5996 30 14.3877 30 14.1666V6.66711C30.0003 6.3051 29.9219 5.94736 29.7701 5.6187C29.6184 5.29005 29.3969 4.99834 29.1211 4.76383Z",
    fill: "url(#paint0_linear_149_79)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6666 10.8334H5C4.33718 10.8341 3.70172 11.0977 3.23303 11.5664C2.76435 12.0351 2.50072 12.6705 2.5 13.3334V31.6666C2.50136 32.7713 2.94078 33.8303 3.72188 34.6114C4.50298 35.3925 5.56199 35.832 6.66664 35.8334H31.6666C32.7713 35.832 33.8303 35.3926 34.6114 34.6114C35.3926 33.8303 35.832 32.7713 35.8334 31.6666V15C35.8321 13.8953 35.3927 12.8362 34.6116 12.0551C33.8304 11.274 32.7713 10.8346 31.6666 10.8334Z",
    fill: "url(#paint1_linear_149_79)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8334 17.5H25C23.898 17.5048 22.8429 17.9459 22.0654 18.7268C21.2878 19.5076 20.8513 20.5647 20.8513 21.6667C20.8513 22.7686 21.2878 23.8257 22.0654 24.6066C22.8429 25.3875 23.898 25.8286 25 25.8334H35.8334C36.2752 25.8329 36.6989 25.6571 37.0113 25.3446C37.3238 25.0322 37.4995 24.6085 37.5 24.1666V19.1666C37.4995 18.7248 37.3238 18.3011 37.0113 17.9887C36.6989 17.6762 36.2752 17.5005 35.8334 17.5Z",
    fill: "url(#paint2_linear_149_79)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25 23.3333C25.9205 23.3333 26.6667 22.5871 26.6667 21.6666C26.6667 20.7462 25.9205 20 25 20C24.0796 20 23.3334 20.7462 23.3334 21.6666C23.3334 22.5871 24.0796 23.3333 25 23.3333Z",
    fill: "url(#paint3_linear_149_79)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_149_79",
    x1: 4.24112,
    y1: 9.58351,
    x2: 29.6682,
    y2: 9.58351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37AA79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#398A70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_149_79",
    x1: 5.14508,
    y1: 23.3334,
    x2: 36.2273,
    y2: 23.3334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34CA82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37A477"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_149_79",
    x1: 22.1708,
    y1: 21.6666,
    x2: 37.6963,
    y2: 21.6666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F59815"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_149_79",
    x1: 23.2924,
    y1: 21.6666,
    x2: 26.5753,
    y2: 21.6666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EBE6"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/coin.d45ffc14205fe1d141afe916850a3ffb.svg";
export { ForwardRef as ReactComponent };